import useStyles from './useStyles'
import { IconButton, Tooltip } from '@mui/material'
import ModalMenuItem from '../../Modals/ModalMenuItem.jsx'
import GppGoodOutlinedIcon from '@mui/icons-material/GppGoodOutlined'
import GppBadOutlinedIcon from '@mui/icons-material/GppBadOutlined'

function TableItem ({ item, setLoading, role, userInstance }) {
  const classes = useStyles()

  const getIconStatus = (code) => {
    switch (code) {
      case 'GRANTED':
        return (
          <Tooltip title="Acceso habilitado">
            <IconButton>
              <GppGoodOutlinedIcon className={classes.hoverButton} />
            </IconButton>
          </Tooltip>
        )
      case 'REVOKED':
        return (
          <Tooltip title={'Acceso revocado'}>
            <IconButton>
              <GppBadOutlinedIcon className={classes.hoverButtonDelete} />
            </IconButton>
          </Tooltip>
        )
      case 'DELETED':
        return (
          <Tooltip title={'Eliminado'}>
            <IconButton>
              <GppBadOutlinedIcon className={classes.hoverButtonDelete} />
            </IconButton>
          </Tooltip>
        )

      default:
        return (
          <Tooltip title={code}>
            <IconButton>
              <GppBadOutlinedIcon className={classes.hoverButtonDelete} />
            </IconButton>
          </Tooltip>
        )
    }
  }

  return (
    <>
      <tr className={classes.row}>
        <td className={classes.itemIcon}>
          {getIconStatus(
            userInstance.userAppAccessStatusCode ||
              item?.status?.userStatusCode
          )}
        </td>
        <td className={classes.itemEmail}>{item?.account?.email}</td>
        <td className={classes.itemName}>
          {item.account?.firstName + ' ' + item.account?.lastName}
        </td>
        <td className={classes.itemRoleUser}>{role?.appRoleName || ''}</td>
        {/* <td className={classes.itemTypeUser}>
          {traducName(item.user?.type?.organizationUserTypeCode) || '- -'}
        </td> */}
        {/* <td className={classes.itemDate}>
          {' '}
          {formatDate(item.startDate)
            ? formatDate(item.startDate)
            : 'Fecha no definida'}{' '}
          /{' '}
          {formatDate(item.finishDate)
            ? formatDate(item.finishDate)
            : 'Fecha no definida'}
        </td>

        <td className={classes.itemTypeComercial}>
          {item.user?.commercialType?.organizationCommercialUserTypeCode ||
            '- -'}
        </td> */}
        <td className={classes.itemKebab}>
          <ModalMenuItem
            item={item}
            userRol={role}
            setLoading={setLoading}
            userInstance={userInstance}
          />
        </td>
      </tr>
    </>
  )
}

export default TableItem
